module.exports = __webpack_public_path__ + "static/Chicory4-30ba53ac6db548e445b7d253a49d68bc.png";